import { WarehouseData } from 'src/atoms/static-data/warehouses-atom'
import { permissionAtom } from './permission-atom'

export function filterAllowedWarehouses(warehouses: Array<WarehouseData>): Array<WarehouseData> {
  const { allowedWarehouseIdsSet } = permissionAtom.getState()

  return warehouses
    .filter(({ id }) => allowedWarehouseIdsSet.has(id))
}
